/**
 * KAN-848: "Проверить все" над списком аккаунтов: проверка авторизации по одному аккаунту
 * с паузой ~3 с, прогресс, остановка. Свежие сессии пропускаются.
 */
import { Button } from '@/components/ui/button';
import {
  BULK_AUTH_CHECK_LABEL,
  BULK_AUTH_CHECK_STOP_LABEL,
  bulkAuthPlan,
} from '@/lib/telegramAuthCheck';
import type { TelegramAccount } from '@/types/telegramAccount';
import { useBulkAuthCheck } from './useBulkAuthCheck';

export function BulkAuthCheck({
  accounts,
  pauseMs,
}: {
  accounts: ReadonlyArray<TelegramAccount>;
  pauseMs?: number;
}): JSX.Element | null {
  const { state, start, stop } = useBulkAuthCheck(pauseMs);
  const plan = bulkAuthPlan(accounts);
  if (!state.running && plan.targets.length === 0 && plan.skippedFresh === 0) return null;

  return (
    <div data-testid="bulk-auth-check" className="flex flex-wrap items-center gap-2 text-xs">
      {state.running ? (
        <>
          <span data-testid="bulk-auth-progress" className="text-gray-600">
            Проверяем авторизацию: {state.done} из {state.total}
          </span>
          <Button
            variant="outline"
            size="sm"
            className="h-7 px-2 text-xs"
            data-testid="bulk-auth-stop"
            onClick={stop}
          >
            {BULK_AUTH_CHECK_STOP_LABEL}
          </Button>
        </>
      ) : (
        <>
          <Button
            variant="outline"
            size="sm"
            className="h-7 px-2 text-xs"
            disabled={plan.targets.length === 0}
            title="Проверить авторизацию всех аккаунтов по очереди"
            data-testid="bulk-auth-start"
            onClick={() => void start(accounts)}
          >
            {BULK_AUTH_CHECK_LABEL} ({plan.targets.length})
          </Button>
          {plan.skippedFresh > 0 && (
            <span data-testid="bulk-auth-skipped" className="text-gray-500">
              Свежие сессии пропускаются: {plan.skippedFresh}
            </span>
          )}
        </>
      )}
    </div>
  );
}
